export enum CampaignDetailApprovalStatus {
  Approved = 1,
  Draft = 2,
  Pending = 3,
  Rejected = 4,
}
